import styled from 'styled-components';

/**
 * @type {import('styled-components').StyledComponent<'div', any, {space?: string}, never>}
 */
export const StackedSpacer = styled.div`
    > *:not(:last-child) {
        display: block;
        ${({space}) => {
            if (space) {
                return ` margin-bottom: var(--space-${space})!important`;
            } else {
                return null;
            }
        }}
    }
`;
